var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyersBriggs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 661.21 824.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:#5fc5d1;}.cls-3{fill:#6bd5e1;}.cls-4{fill:#ffc78e;}.cls-5{fill:none;stroke:#ffd98e;stroke-linecap:round;stroke-linejoin:round;stroke-width:11px;}.cls-6{fill:#ffd98e;}.cls-7{fill:#e49d75;}.cls-8{fill:#e0e0e0;}.cls-9{fill:#ffe4ad;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "directions-colour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.26,219.13c32,60.21-11.12,160.33-36.71,261.29s-33.93,202.2-94.29,253.51c-60.35,51.46-172.85,52.71-264.77,9.18S14.23,611.56,2,520.47s34.35-185,98.32-252.39,145-108.47,239.33-118.76S541.14,159.05,573.26,219.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "633.23 41.13 439.01 82.8 439.01 42.13 632.43 0.64 661.21 15.62 633.23 41.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "439.01 42.13 242.63 0 216.82 14.85 240.38 40.19 439.01 82.8 439.01 42.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.36,644.53c-1,13.85-7,76.42-2.9,95.71h178l-18.31-92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.56,434.08c22.23-14.85,76.14,44.47,78.58,62.1-5.44,9-43.8,35.6-57.92,34.12C180.29,518.25,153.11,448.4,174.56,434.08Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 439.01,
    y1: 18.3,
    x2: 439.01,
    y2: 818.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.07,405.53c128.08,0,108.42,210.8,100.22,246.87-32.62,18.33-137.15,15.77-167.39-3.67C46.31,588.5,44.94,405.53,125.07,405.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25.74,511.57c-3.58,12-15.93,107,3,121.34s89.13-37.76,101.66-48.5-2.51-28.45-15.84-24.7S73,573.32,67.8,576.54c5-11.46,14.31-43.31,14.22-52.08S25.74,511.57,25.74,511.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "388.04 614.61 131.57 684.6 131.57 489.96 388.04 419.97 388.04 614.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "439.01 83.45 244.52 125.17 216.82 110.58 236.85 86.15 439.01 42.78 439.01 83.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "635.91 85.02 439.01 42.78 439.01 83.45 633.51 125.17 661.21 109.82 635.91 85.02"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.56,
    cy: 276.14,
    r: 49.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 140.02,
    cy: 336.49,
    r: 58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.93,379.33c37-29.17,45.21-75.41,46.24-100.39a60.06,60.06,0,0,0-7.15-.45,58,58,0,0,0-39.09,100.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,303.6a69.38,69.38,0,0,0,13.38-1.3,58.06,58.06,0,0,0-64.32-21.13A68.9,68.9,0,0,0,173.49,303.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M153.74,424.43c0,7.55-41.23,7.39-41.23,0V370.11h41.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.51,428.86c26.35,4.53,24.62,84.66,14.25,99.13-10.15,2.81-56.27-4.32-65.5-15.11C17.73,493.87,46.09,424.48,71.51,428.86Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 136.78,
    cy: 557.32,
    rx: 24.26,
    ry: 28.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 383.25,
    cy: 500.6,
    rx: 14.21,
    ry: 23.47
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyersBriggs);
export default __webpack_public_path__ + "static/media/myersBriggs.d53603e1de9b8e4c07ca6c75bc96a056.svg";
export { ForwardRef as ReactComponent };